import React from 'react';
import { TooltipTableCell } from '../TooltipTableCell';

export const ApproverWithTooltip = {
    Header: () => 'Aprobador',
    id: 'aprobador',
    Cell: ({ row }) => (
        <TooltipTableCell
            label={row.original.gestionsolicitud?.usuario_comite?.name}
            tooltipText={row.original.gestionsolicitud?.usuario_comite?.email}
            emptyText=""
        />
    ),
};
